import { render, staticRenderFns } from "./subsidiary.vue?vue&type=template&id=61183037&scoped=true"
import script from "./subsidiary.vue?vue&type=script&lang=js"
export * from "./subsidiary.vue?vue&type=script&lang=js"
import style0 from "./subsidiary.vue?vue&type=style&index=0&id=61183037&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61183037",
  null
  
)

export default component.exports